import { useCallback } from 'react'
import { ActionButton } from '@my/ui'
import { useAuthedPlaidLink } from '@my/util'
//import "@copilotkit/react-textarea/dist/index.css"; // also import this if you want to use the CopilotTextarea component

export const SimplePlaidLink = () => {
  const onSuccess = useCallback((plaidData) => {
    // send public_token to your server
    // https://plaid.com/docs/api/tokens/#token-exchange-flow
  }, [])

  const { open, ready } = useAuthedPlaidLink({
    onSuccess,
    // onEvent
    // onExit
  })

  return (
    <>
      {JSON.stringify({ ready })}
      <ActionButton onPress={() => open()} disabled={!ready}>
        Connect a bank account
      </ActionButton>
    </>
  )
}
